
import * as THREE from 'three';
import Phobject from './Phobject.js'

export default class Book extends Phobject {
    constructor(frontImage, backImage, spineImage){
        super(true);
        
        let toM = function(n){
            return n/39.37;
        }
        this.dimBook = new THREE.Vector3(toM(10),toM(12),toM(1));

        this.group = new THREE.Group();

        // pages are a boxgeo

        // front, back, and spine are plane geo
        var texFront = new THREE.TextureLoader().load( frontImage );
        var texBack = new THREE.TextureLoader().load( backImage );
        var texSpine = new THREE.TextureLoader().load( spineImage );
        
        // front cover
        var geoCoverFront = new THREE.PlaneGeometry( this.dimBook.x, this.dimBook.y );
        var matCoverFront = new THREE.MeshBasicMaterial( {
            color: 0xffffff,  
            side: THREE.DoubleSide,
            map: texFront
        });
        let meshCoverFront = new THREE.Mesh( geoCoverFront, matCoverFront );
        meshCoverFront.position.z = this.dimBook.z/2;

        var geoCoverBack = new THREE.PlaneGeometry( this.dimBook.x, this.dimBook.y );
        var matCoverBack = new THREE.MeshBasicMaterial( {
            color: 0xffffff,  
            side: THREE.DoubleSide,
            map: texBack
        });
        let meshCoverBack = new THREE.Mesh( geoCoverBack, matCoverBack );
        meshCoverBack.position.z = -this.dimBook.z/2
        meshCoverBack.rotation.y = Math.PI
        
        var geoCoverSpine = new THREE.PlaneGeometry( this.dimBook.z, this.dimBook.y );
        var matCoverSpine = new THREE.MeshBasicMaterial( {
            color: 0xffffff,  
            side: THREE.FrontSide,
            map: texSpine
        });
        let meshCoverSpine = new THREE.Mesh( geoCoverSpine, matCoverSpine );
        meshCoverSpine.position.x = -this.dimBook.x/2
        meshCoverSpine.rotation.y = -Math.PI/2;

        let pageInsets = new THREE.Vector3(toM(.5),toM(.5),toM(.02))
        var matPages = new THREE.MeshBasicMaterial( {color: 0xBBBBBB});
        var geoPages = new THREE.BoxBufferGeometry( this.dimBook.x-pageInsets.x,this.dimBook.y-pageInsets.y,this.dimBook.z-pageInsets.z);
        this.meshPages = new THREE.Mesh( geoPages, matPages );
        this.meshPages.position.x = -pageInsets.x/2 + .01;        
        
        this.group.add(meshCoverFront);
        this.group.add(meshCoverBack);
        this.group.add(meshCoverSpine);
        this.group.add(this.meshPages);

        this.meshPages.userData = this;
    }

    getObject(){
        return this.group;
    }

    canFocus(){
        return true;
    }    
    getOutlineMeshes(){
        return [this.meshPages]
    }
    getFocusMode(){
        return "book"
    }


    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'box',
            size:[this.dimBook.x, this.dimBook.y, this.dimBook.z],
            pos:[pos.x,pos.y,pos.z],
            density:5,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
        this.phobject.angularVelocity.z=(Math.random()-.5)*2;
        this.phobject.angularVelocity.x=-Math.random();
    }
}
